//localhost
// export const ENV = "http://localhost:3000"

//production
export const ENV = "https://cms.letsgocredit.com.hk"
